import type { DiscoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemAuthorBasicInfo } from './discoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemAuthorBasicInfo';
import type { DiscoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemAuthorSocial } from './discoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemAuthorSocial';

/**
 * 트윗 작성자 정보
 */
export type DiscoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemAuthor = {
  /** 사용자 기본 정보 */
  basicInfo: DiscoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemAuthorBasicInfo;
  /** 소셜 관계 정보 */
  social?: DiscoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemAuthorSocial;
};
